/* eslint-disable */

export const MODERN_NODE_CONFIGS = {
    processFlow: {
        layout: 'vertical',
        cardWidth: '110rem',
        padding: 'p-4',
        borderRadius: 'rounded-[2rem]',
        showHandles: true,
        showMachine: true,
        showPhone: true,
        showAsset: true,
        showDefaultMode: true,
        showMachineStatus: true,
        showMetrics: true,
        showWorkOrders: true,
        showRecipeStats: true,
        showActions: true,
        enableHover: true,
        header: {
            iconSize: 'h-[14rem]',
            titleSize: 'text-[8rem]',
            subtitleSize: 'text-[5rem]',
            layout: 'horizontal',
        },
        metrics: {
            iconSize: 'w-[150px] h-[150px]',
            percentSize: 'text-[8rem]',
            valueSize: 'text-[7rem]',
            layout: 'horizontal',
            showProgressBar: true,
        },
        recipeStats: {
            titleSize: 'text-[8rem]',
            labelSize: 'text-[5rem]',
            valueSize: 'text-[6.5rem]',
        },
        mode: {
            fontSize: 'text-[5rem]',
        },
        workOrders: {
            fontSize: 'text-[5rem]',
            iconSize: 100,
        },
        actions: {
            iconSize: 100,
        }
    },
};

export default MODERN_NODE_CONFIGS;
